var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pwa-widget-edit"},[_vm._m(0),_vm._v(" "),_c('menu-item',{attrs:{"label":"移动端描述图片"}},[_c('menu-background-image',{attrs:{"target":_vm.model.guidBackground,"target-key":"guidBackground","event-key":"pwa-guid-image"}})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip"},[_c('span',[_vm._v("使用PWA功能，用户可以将网页应用安装至桌面，方便其快速访问。应用图标使用 SEO图标。")])])
}]

export { render, staticRenderFns }